import React from "react";
import "./PWall.scss";
import Xbutton from "components/Xbutton";
import { useTranslation } from "react-i18next";

export default function PWall_Processing({ onExit }) {
  const { t } = useTranslation();
  return (
    <>
      <div className="PWall_container">
        <div className="PWall_container__nav">
          <Xbutton sizeM onClose={onExit} />
        </div>
        <div className="PWall_content">
          <div className="PWall_container__right">
            <div className="content" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img src="/bouncing-ball-preloader.gif" alt="Loading..." style={{ width: 64, height: 64, marginBottom: 16 }} />
              <div className="PWall_success-title">
                {t('paywall.processing') || 'Processing your subscription...'}
              </div>
              <div className="PWall_-description" style={{ textAlign: 'center', marginTop: 8 }}>
                {t('paywall.processingDescription') || "Please don't close this window. This may take a few seconds."}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}


